import 'jquery';
import 'underscore';

import TrackerView from 'core/views/tracker';
import Screener from 'screener/models/screener_set_item';
import ScreenerView from 'screener/views/screener';


export default TrackerView.extend({
  // Inherit from this view if there are screeners on the page

  personal_strengths: function () {
    // Setup strengths finder box in the right rail
    var self = this;
    var strengths_link = $('#strengths-list a', this.el);
    if (strengths_link.length) {
      this.screener_set_item = new ScreenerSetItem();
      this.screener_set_item.params.screener__slug = 'strengths-finder';
      this.screener_view = new ScreenerView({
        el: $('#wrap'),
        model: this.screener_set_item
      });
      this.screener_set_item.fetch({ cache: false, success: function () {
        self.screener_view.render();
        var href = '#screener-modal-' + self.screener_set_item.get('id');
        strengths_link.attr('href', href);
        strengths_link.attr('data-toggle', 'modal');
      } });
      this.screener_view.on('screener-results', this.update_strengths);
    }
  },

  update_strengths: function (user_progress) {
    // Update list of strengths in the sidebar
    var strengths_sidebar = $('#strengths-list');
    var strengths_list = $('ul', strengths_sidebar);
    $('li:not(:last-child)', strengths_list).remove();
    _.each(user_progress.get('options'), function (option) {
      strengths_list.prepend('<li>' + option.value + '</li>');
    });
    strengths_list.removeClass('hide');
    $('#default-strengths', strengths_sidebar).addClass('hide');
  },

  check_screener_readiness: function () {
    var screeners_ready = true;
    _.each(this.screener_views, function (screener_view) {
      if (!screener_view.ready) {
        screeners_ready = false;
      }
    });
    if (screeners_ready) {
      this.trigger('screeners-ready');
    }
  },

  screener_views: [],
  create_screener_views: function () {
    // Create screener views
    var self = this;
    this.screener_views = [];
    this.screener_set_item_collection.each(function (ssi) {
      if (!_.contains(_.keys(ssi), 'view') || ssi.view === null) {
        var screener_view = new ScreenerView({
          el: $('#wrap'),
          model: ssi,
          panel: $('#screener-set-item-' + ssi.get('id')),
          parent_view: self
        });
        screener_view.on('screener-results', function (user_progress) {
          if (self.user_progress_collection) {
            self.user_progress_collection.add(user_progress);
            self.render_plan();
            this.renderPanel();
            window.scrollTo(0, 0);
            // Invalidate the user_progress collection cache and
            // update the collection.
            Backbone.fetchCache.clearItem(self.user_progress_collection.url());
            self.user_progress_collection.fetch({ cache: true, expires: 86400 });
          }
        });
        // Set up the strengths finder link in the right rail to open
        // the strengths finder modal
        if (ssi.get('screener').slug == 'strengths-finder') {
          var strengths_link = $('#strengths-list a', self.el);
          if (strengths_link.length) {
            strengths_link.attr('href', '#screener-modal-' + ssi.get('id'));
            strengths_link.attr('data-toggle', 'modal');
          }
          screener_view.on('screener-results', self.update_strengths);
        }
        screener_view.on('ready', _.bind(self.check_screener_readiness, self));
        screener_view.render();
        self.screener_views.push(screener_view);
      }
    });
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/views/page.js
// module id = 36
// module chunks = 0